import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const C = {
  flamenco: "#F05260",
  flamencoSoft: "#F47781",
  flamencoPale: "#FDE8EA",
  skyfall: "#84D5F7",
  skyfallSoft: "#A8E0F9",
  skyfallPale: "#E0F4FE",
  mintleaf: "#4EB969",
  mintleafSoft: "#7DD392",
  mintleafPale: "#DFF5E5",
  plumwood: "#842885",
  plumwoodSoft: "#B666B7",
  plumwoodPale: "#F3DAF4",
  warmBg: "#FAF7F2",
  warmBgAlt: "#F5F0EB",
  cream: "#FFF9F4",
  cardBg: "#FFFFFF",
  textPrimary: "#2A2230",
  textSecondary: "#5E5568",
  textMuted: "#8A8290",
  shadow: "rgba(42, 34, 48, 0.08)",
  shadowHover: "rgba(42, 34, 48, 0.15)",
};

export const nav: NavPalette = {
  surface: "rgba(255, 249, 244, 0.94)",
  surfaceHover: "rgba(245, 240, 235, 0.96)",
  border: "rgba(42, 34, 48, 0.18)",
  text: "#2A2230",
  textMuted: "rgba(94, 85, 104, 0.85)",
  activeBg: "rgba(243, 218, 244, 0.75)",
  activeText: "#842885",
};

const BOOKS = [
  {
    title: "The Singing Snail",
    author: "Maya Torres",
    grade: "Grade 1",
    tags: ["Sight Words", "Nature", "Music"],
    color1: C.skyfall,
    color2: C.mintleaf,
    color3: C.flamenco,
    emoji: "\uD83D\uDC0C",
    description:
      "Follow Shelly the snail on a rhythmic journey through the garden, discovering that every creature has its own song. Perfect for building sight vocabulary through melody and repetition.",
  },
  {
    title: "Captain Codebreaker",
    author: "James Li",
    grade: "Grade 2",
    tags: ["Adventure", "Problem Solving"],
    color1: C.plumwood,
    color2: C.flamenco,
    color3: C.skyfall,
    emoji: "\uD83D\uDD75\uFE0F",
    description:
      "A thrilling adventure where young readers decode secret messages, building sight vocabulary and reading confidence one clue at a time.",
  },
  {
    title: "Moonbeam Meadow",
    author: "Sara Okun",
    grade: "Grade 1",
    tags: ["Fantasy", "Rhyming", "Bedtime"],
    color1: C.mintleaf,
    color2: C.skyfall,
    color3: C.plumwood,
    emoji: "\uD83C\uDF19",
    description:
      "A dreamy bedtime story where fireflies teach new words through gentle rhymes under the moonlit sky.",
  },
  {
    title: "The Word Wizard",
    author: "Priya Anand",
    grade: "Grade 3",
    tags: ["Vocabulary", "Magic", "Humor"],
    color1: C.flamenco,
    color2: C.plumwood,
    color3: C.mintleaf,
    emoji: "\uD83E\uDDD9",
    description:
      "When Zara discovers a dictionary that brings words to life, she must master syllables and sight words to save her school from a vocabulary villain.",
  },
];

export const FEATURED = BOOKS[0] ??
  BOOKS[1] ?? {
    title: "",
    author: "",
    grade: "",
    tags: [] as string[],
    color1: C.skyfall,
    color2: C.mintleaf,
    color3: C.flamenco,
    emoji: "",
    description: "",
  };

export const LIBRARY = [
  BOOKS[1] ?? BOOKS[0]!,
  BOOKS[2] ?? BOOKS[0]!,
  BOOKS[3] ?? BOOKS[0]!,
];

export const VALUE_PROPS = [
  {
    icon: "\uD83D\uDC42",
    title: "Listen & Learn",
    body: "The EAR method starts with engaged listening. Children hear fluent reading modeled aloud, absorbing rhythm, pronunciation, and expression before they ever read a word on their own.",
    color: C.skyfall,
    chipColor: C.skyfallPale,
  },
  {
    icon: "\uD83E\uDD1D",
    title: "Guided Practice",
    body: "Aided reading bridges the gap between listening and independence. Interactive prompts, gentle scaffolding, and real-time feedback help children build confidence one page at a time.",
    color: C.mintleaf,
    chipColor: C.mintleafPale,
  },
  {
    icon: "\uD83D\uDE80",
    title: "Read Solo",
    body: "Children graduate to independent reading with the skills and confidence they've built. Comprehension quizzes, streak rewards, and personalized book picks keep motivation soaring.",
    color: C.flamenco,
    chipColor: C.flamencoPale,
  },
];
